import React from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';

const AcademicPeriod = ({ data: period, onPeriod }) => {
  const handleChange = ({ target: input }) => {
    onPeriod(input.value);
  };

  return (
    <InputText
      name='period'
      value={period}
      label='Período académico *'
      size='small'
      variant='outlined'
      onChange={handleChange}
      placeholder='AGOSTO 2021 - FEBRERO 2022'
      margin='normal'
    />
  );
};

const InputText = styled(TextField)`
  width: 60%;
`;

export default AcademicPeriod;
